import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/InventoryRelocationReport/InventoryRelocationReportAction'


//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WarehouseReportInventoryRelocationActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/InventoryRelocationReport/InventoryRelocationReport")
	}

	render() {
		return (
			<Activity 
				name="InventoryRelocationReport"
				RenderedComponent={this.RenderedComponent}
				context="InventoryRelocationReport"
				action="InventoryRelocationReport"
				formActions={FormAction}
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(WarehouseReportInventoryRelocationActivity)
